import {
  removeRouterManagedMetaTags,
  addRouterManagedMetaTag,
} from './metaTagHelpers'
import { RouteLocationNormalized } from 'vue-router'

const defaultTitle = 'Jobscan'
const defaultDescription =
  'Jobscan is built from algorithms used in top Applicant Tracking Systems (ATS). Optimize your resume keywords and get more interviews.'
const defaultRobots = ''

export const applyPageMeta = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized
) => {
  document.title = (to.meta?.title || defaultTitle) as string

  removeRouterManagedMetaTags()
  addRouterManagedMetaTag('description', defaultDescription, to)

  if (to.meta?.robots) {
    addRouterManagedMetaTag('robots', defaultRobots, to)
  }

  return true
}

export default applyPageMeta
